import { ClassProvider, InjectionToken, Type } from "@angular/core";
import { IActivitiesGroupedByActivityType, IActivityEntityType, IActivityGroup, IActivityGroupStatuses, ICalendarCulturalActivity } from "@org-common/lib/activities/activities-metadata";
import { ActivityType } from "@org-common/lib/cultural-activity/cultural-activity-type-metadata";
import { Observable } from "rxjs";

export abstract class ActivityHandler<T extends IActivityEntityType = IActivityEntityType> {
    public abstract entityType: new (...args: any[]) => T;
    public abstract activityTypes: ActivityType[];
    public abstract shouldUpdate$: Observable<ActivityType[]>;

    public abstract getGroupedActivities(personId: number, startDate?: Date, endDate?: Date, excludeCompleted?: boolean, typesToUpdate?: ActivityType[]): Promise<Partial<IActivitiesGroupedByActivityType>>;

    public groupActivitiesByStatus(group: IActivityGroup<T>): IActivityGroupStatuses {
        return group;
    }

    public abstract getCalendarEventForActivity(activity: T): Promise<Pick<ICalendarCulturalActivity, "title" | "startDate" | "endDate" | "completed">>;
}

export const ACTIVITY_HANDLERS = new InjectionToken<ActivityHandler[]>("ACTIVITY_HANDLERS");

export function provideActivityHandler(builderType: Type<ActivityHandler>): ClassProvider {
    return {
        provide: ACTIVITY_HANDLERS,
        useClass: builderType,
        multi: true,
    };
}
